module.exports = __webpack_public_path__ + "static/media/p208cover2.a27b4403.png";